import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
  selector: 'mtg-audio',
  templateUrl: './audio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AudioComponent implements OnChanges {
  @Input()
  source: string;
  @Input()
  name: string;
  state: 'playing' | 'pause' | 'loading' = 'pause';
  progress: number;
  duration: number;
  private audio = new Audio();

  constructor(
    private cdr: ChangeDetectorRef,
  ) {
  }

  detectChanges(): void {
    if (this.audio) {
      this.audio.pause();
    }
    if (this.source) {
      this.initializeAudio();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.source) {
      this.detectChanges();
    }
  }

  initializeAudio(): void {
    this.audio = new Audio(this.source);
    this.audio.addEventListener('playing', () => {
      this.state = 'playing';
      this.cdr.markForCheck();
    });
    this.audio.addEventListener('pause', () => {
      this.state = 'pause';
      this.cdr.markForCheck();
    });
    this.audio.addEventListener('timeupdate', event => {
      this.progress = 100 * this.audio.currentTime / this.duration;
      this.cdr.markForCheck();
    });
    this.audio.addEventListener('durationchange', event => {
      this.duration = this.audio.duration;
      this.cdr.markForCheck();
    });
  }

  togglePlay(): void {
    if (this.audio.paused) {
      this.playAudio();
    } else {
      this.audio.pause();
    }
  }


  playAudio(): void {
    this.state = 'loading';
    this.audio.play().catch(error => {
      this.state = 'pause';
    });
  }

  pauseAudio(): void {
    this.audio.pause();
  }

  setMeta(name: string, source: string): void {
    this.name = name;
    if (!this.source || this.source !== source) {
      this.source = source;
      this.detectChanges();
    }
  }

  setDuration(event): void {
    const rect = event.target.getBoundingClientRect();
    const progress = (event.clientX - rect.x) / rect.width;
    if (progress < 0 || progress > 1) {
      return;
    }
    this.audio.currentTime = progress * this.duration;
  }

  strPadLeft(time, pad, length) {
    return (new Array(length + 1).join(pad) + time).slice(-length);
  }

  getPrettyTime(time: number): string {
    if (!time) {
      return '';
    }
    const minutes = Math.floor(time / 60);
    const seconds = Math.round(time - minutes * 60);
    return `${minutes}:${this.strPadLeft(seconds, '0', 2)}`;

  }

  get durationInfo(): string {
    return this.audio.currentTime
      ? this.getPrettyTime(this.audio.currentTime)
      : this.getPrettyTime(this.audio.duration);
  }
}
